<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto">
      <el-row style="height: 100%;">
        <el-col :span="4" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <tree-data ref="tree" @checkChange="checkChange"></tree-data>
        </el-col>
        <el-col :span="20" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <div style="height: 50px">
            <el-button type="primary" plain icon="el-icon-plus" @click="addServiceObj()">新 建</el-button>&nbsp;
            <el-input prefix-icon="el-icon-search" placeholder="输入姓名、电话、住址搜索" v-model="searchKeyword" style="width: 350px" @blur="blurSearch()">
            </el-input>
            <el-button icon="el-icon-search" type="primary" plain @click="searchWord1()">搜索</el-button>
            <el-button icon="el-icon-download" type="success" @click="getAllData1">导出</el-button>
          </div>
          <div style="max-height: calc(100% - 100px);overflow-y: auto;">
            <el-table
              v-loading="loading"
              element-loading-text="加载中，请耐心等待。"
              :data="showTable1"
              border
              style="width: 100%"
              highlight-current-row
              ref="singleTable">
              <!--tbdata-->
              <el-table-column
                type="index"
                label="序号"
                width="50"
                 align="center">
              </el-table-column>
              <el-table-column
                prop="name"
                label="姓名"
                min-width="60"
                 align="center">
              </el-table-column>
              <el-table-column
                label="性别"
                width="50"
                 align="center">
                <template slot-scope="scope">
                  <span>{{getSex(scope.row.sex)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="birthday"
                label="出生日期"
                min-width="70"
                 align="center">
              </el-table-column>
              <el-table-column
                prop="phone"
                label="电话号码"
                min-width="90"
                 align="center">
              </el-table-column>
              <el-table-column
                prop="h_address"
                label="家庭地址"
                min-width="90"
                 align="center">
              </el-table-column>
              <el-table-column
                label="服务频率"
                min-width="70"
                 align="center">
                <!-- prop="frequency"-->
                <template slot-scope="scope">
                  <span>{{getFrequencyName(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="所属项目"
                min-width="70"
                 align="center">
                <!-- prop="projectname"-->
                <template slot-scope="scope">
                  <span>{{getProjectName(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="项目备注"
                min-width="70"
                 align="center">
                <!--prop="projectremark"-->
                <template slot-scope="scope">
                  <span>{{getProjectRemark(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="timelist"
                label="接听电话时间段"
                min-width="90"
                 align="center">
              </el-table-column>
              <el-table-column
                prop="circumstances"
                label="特殊情况"
                min-width="80"
                align="center">
              </el-table-column>
              <el-table-column
                label="生命体征"
                min-width="70"
                align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.is_dead === 0">在世</span>
                  <span v-else>离世</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="createtime"
                label="建档录入时间"
                min-width="95"
                align="center">
              </el-table-column>
              <el-table-column align="center" label="操作" width="300"  class-name="small-padding fixed-width">
                <template slot-scope="scope">
<!--                  <i title="通话视频" v-if="$store.state.user.role === 'superadmin' && $store.state.user.moduletag !== 2" class="el-icon-video-camera" style="cursor: pointer; font-size: 18px;color: #002dc0" @click="callServiceObj(scope.row)"></i>-->
<!--                  <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editServiceObj(scope.row)"></i>-->
<!--                  <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delServiceObj(scope.row)"></i>-->
                  <el-button size="mini" type="warning" plain @click="openGrade(scope.row)">评估</el-button>
                  <el-button v-if="$store.state.user.role === 'superadmin' && $store.state.user.moduletag !== 2" size="mini" type="primary" plain @click="callServiceObj(scope.row)">通话</el-button>
                  <el-button size="mini" type="primary" plain @click="editServiceObj(scope.row)">档案</el-button>
                  <el-button size="mini" type="danger" plain @click="delServiceObj(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 10px;height: 40px;text-align: center" v-if="!isNumber">
            <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
              layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--联系人-->
    <el-dialog :title="familyTitle" :visible.sync="familyShow" v-if="familyShow" :close-on-click-modal="false"
      width="900px" top="10vh" center>
      <see-family :familyData="familyShowData" v-model="familyShow"></see-family>
    </el-dialog>
    <!--快捷编辑服务对象-->
    <el-dialog :visible.sync="quickShow" v-if="quickShow" :close-on-click-modal="false"
      width="1180px" center class="all-open">
      <quick-open :quickObj="quickObj" v-model="quickShow"></quick-open>
    </el-dialog>
    <!--  能力评估  -->
    <el-dialog :visible.sync="evaluateShow" v-if="evaluateShow" width="1200px"
               :show-close="true" :close-on-click-modal="true" center class="all-open">
      <evaluate-history v-model="evaluateShow" :evaluateObj="evaluateObj"></evaluate-history>
    </el-dialog>
    <!--免责条款-->
    <el-dialog title="免责条款" :visible.sync="disclaimerShow" v-if="disclaimerShow" :close-on-click-modal="false"
               width="500px" center>
      <div style="padding: 10px 20px;line-height: 1.8;font-size: 14px;color: #333">
        <p>本次导出内容包含老人隐私信息，受法律法规保护。请妥善保管数据，不得擅自传播、泄露、转借及二次利用。</p>
        <p>确认即代表您知晓并承诺遵守隐私保护相关规定，违规需承担相应法律责任。</p>
      </div>
      <div style="height: 40px">
        <el-row>
          <el-col :span="12">
            <div class="cancel-btn" @click="disclaimerShow = false"><span>取消</span></div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="confirmDisclaimer()"><span>确认并继续</span></div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!--导出密码验证-->
    <el-dialog title="导出验证" :visible.sync="pwdShow" v-if="pwdShow" :close-on-click-modal="false"
               width="500px" center>
      <el-form style="margin: 0 30px" :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="验证密码" prop="pwd">
          <el-input v-model="pwdForm.pwd" type="password" show-password placeholder="请输入登录密码"></el-input>
        </el-form-item>
      </el-form>
      <div style="height: 40px">
        <el-row>
          <el-col :span="12">
            <div class="cancel-btn" @click="pwdShow = !pwdShow"><span>取消</span></div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitPwd('pwdForm')"><span>确认导出</span></div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import seeFamily from './childComponents/seeFamily'
import quickOpen from './quick/quickOpen'
import evaluateAbility from './childComponents/evaluateAbility'
import {queryfrequency, queryproject, deleteoldperson, queryoldpersonpage, queryoldpersonbyoids, searcholdperson, querybinddevicebyhome} from '../../api/serviceObject'
import {searchpersonbyphone} from '../../api/handlealarm'
import treeData from '../treeData/treeData.vue'
import {verifypwd} from '../../api/login'
import evaluateHistory from '../oldPersonHome/components/evaluateHistory.vue'
import {queryorgcommunity} from '../../api/community'
import {getUsername} from '../../utils/auth'
import {addexportlog} from '../../api/log'

export default {
  name: 'serviceObject',
  components: {evaluateHistory, treeData, seeFamily, quickOpen, evaluateAbility},
  data () {
    return {
      // 左边
      isNumber: false,
      searchKeyword: '',
      treeData: [],
      isFirst: [],
      // 右边
      tableData: [],
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      addEdit: {
        isAdd: true,
        row: {},
        orgTree: [],
        orgData: [],
        frequencys: [],
        projects: []
      },
      orgid: '',
      frequencys: [],
      projects: [],
      familyTitle: '',
      familyShow: false,
      familyShowData: {
        row: {}
      },
      showTable1: [],
      oids: [],
      quickShow: false,
      quickObj: {
        quickTitle: '',
        isQuick: false,
        isAdd: true, // 是否新建或更新
        oldPersonRow: '',
        orgOptions: [],
        frequencys: [],
        projects: []
      },
      // 能力评估
      evaluateShow: false,
      evaluateObj: {
        oldPersonRow: ''
      },
      pwdShow: false,
      pwdForm: {
        pwd: ''
      },
      pwdRules: {
        pwd: [{required: true, message: '请输入登录密码', trigger: 'blur'}]
      },
      // 组织数据（由 treeData 组件回传）
      orgData: [],
      // 小区/机构数据
      communitys: [],
      // 免责条款弹窗
      disclaimerShow: false
    }
  },
  created () {
    this.golobleObject.updateTableSerObj = this.getUpdateTable
    this.orgid = this.$store.state.user.orgid
    this.getFrequency()
    this.getCommunityList()
  },
  mounted () {
  },
  computed: {
    // tbdata () {
    //   return this.searchFilterWord()
    // }
  },
  methods: {
    searchWord1 () {
      this.currentPage = 1
      this.pageSize = 10
      if (/^\d+$/.test(this.searchKeyword)) {
        this.isNumber = true
        this.getOldPersonTableByPhone()
      } else {
        this.isNumber = false
        this.searchWord()
      }
    },
    // 通过手机号查找服务对象
    getOldPersonTableByPhone () {
      let data = {
        phone: this.searchKeyword
      }
      searchpersonbyphone(data).then(res => {
        this.showTable1 = res.data.person
      }).catch(() => {})
    },
    // 搜索
    searchWord () {
      let data = {
        lessname: this.searchKeyword,
        page: this.currentPage,
        size: this.pageSize
      }
      if (data.lessname !== '') {
        searcholdperson(data).then(res => {
          this.totalCells = res.data.cnt
          this.showTable1 = res.data.persons
        }).catch(() => {})
      } else {
        if (this.oids.length === 0) {
          this.getOldPersonTable()
        } else {
          this.getOldPersonTableByOids()
        }
      }
    },
    blurSearch () {
      if (this.searchKeyword === '') {
        this.isNumber = false
        if (this.oids.length === 0) {
          this.getOldPersonTable()
        } else {
          this.getOldPersonTableByOids()
        }
      }
    },
    // 左边组织查询老人
    getOldPersonTableByOids () {
      this.loading = true
      let data = {
        oids: this.oids,
        page: this.currentPage,
        size: this.pageSize
      }
      queryoldpersonbyoids(data).then(res => {
        this.loading = false
        this.showTable1 = res.data.persons
        this.totalCells = res.data.cnt
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页表格
    getOldPersonTable () {
      this.loading = true
      let data = {
        orgid: this.orgid,
        page: this.currentPage,
        size: this.pageSize
      }
      queryoldpersonpage(data).then(res => {
        this.loading = false
        this.showTable1 = res.data.oldpersons
        this.totalCells = res.data.cnt
      }).catch(() => {
        this.loading = false
      })
    },
    // 导出 —— 先弹免责条款，确认后再验证密码
    getAllData1 () {
      this.disclaimerShow = true
    },
    // 用户确认免责条款后，进入密码验证
    confirmDisclaimer () {
      this.disclaimerShow = false
      this.pwdForm.pwd = ''
      this.pwdShow = true
    },
    submitPwd (formName) {
      let data = {
        pwd: this.pwdForm.pwd
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          verifypwd(data).then(res => {
            // this.$message({ type: 'success', message: '验证成功', duration: 2000 })
            this.pwdShow = false
            this.getAllData()
          }).catch(() => {})
        }
      })
    },
    getAllData () {
      this.$message({ type: 'info', message: '数据加载中，请耐心等待。', duration: 0 })
      if (this.searchKeyword === '') {
        if (this.oids.length === 0) {
          this.getOldPersonTableDown()
        } else {
          this.getOldPersonTableByOidsDown()
        }
      } else {
        // 搜索导出
        this.searchWordDown1()
      }
    },
    getOldPersonTableDown () {
      let data = {
        orgid: this.orgid,
        page: 1,
        size: this.totalCells
      }
      queryoldpersonpage(data).then(res => {
        let arr = res.data.oldpersons
        if (res.data.cnt === 0) {
          this.$message.closeAll()
          this.$message({
            type: 'success',
            message: '暂无报警信息。'
          })
        } else {
          this.download2(arr)
        }
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    getOldPersonTableByOidsDown () {
      let data = {
        oids: this.oids,
        page: 1,
        size: this.totalCells
      }
      queryoldpersonbyoids(data).then(res => {
        let arr = res.data.persons
        if (res.data.cnt === 0) {
          this.$message.closeAll()
          this.$message({
            type: 'success',
            message: '暂无报警信息。'
          })
        } else {
          this.download2(arr)
        }
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    searchWordDown1 () {
      let data = {
        lessname: this.searchKeyword,
        page: 1,
        size: 10
      }
      searcholdperson(data).then(res => {
        let arr = res.data.persons
        if (res.data.cnt === 0) {
          this.$message.closeAll()
          this.$message({
            type: 'success',
            message: '暂无报警信息。'
          })
        }
        if (res.data.cnt > 10) {
          this.searchWordDown2(res.data.cnt)
        } else if (res.data.cnt > 0 && res.data.cnt <= 10) {
          this.download2(arr)
        }
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    searchWordDown2 (cnt) {
      let data = {
        lessname: this.searchKeyword,
        page: 1,
        size: cnt
      }
      searcholdperson(data).then(res => {
        let arr = res.data.persons
        this.download2(arr)
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    download2 (arr) {
      // 判断是否为授权用户（可导出扩展字段）
      const allowedUsers = ['demoadmin1', '沙湾市管理员']
      const isPrivileged = allowedUsers.indexOf(getUsername()) > -1

      // 构造筛选描述
      let filterDesc = ''
      if (this.searchKeyword) {
        filterDesc = '搜索：' + this.searchKeyword
      } else if (this.oids && this.oids.length > 0) {
        filterDesc = '按组织筛选，共' + this.oids.length + '个组织'
      } else {
        filterDesc = '全量导出'
      }

      if (!isPrivileged) {
        // 普通用户：原有字段导出
        let arr1 = arr.map(item => {
          let obj = Object.assign({}, item)
          obj.sexShow = this.getSex(obj.sex)
          obj.frequencyShow = this.getFrequencyName(obj)
          obj.projectShow = this.getProjectName(obj)
          obj.projectNoteShow = this.getProjectRemark(obj)
          return obj
        })
        import('../../vendor/Export2Excel').then(excel => {
          const tHeader = ['姓名', '性别', '出生日期', '电话号码', '家庭地址', '服务频率', '所属项目', '项目备注', '接听电话时间段', '特殊情况', '建档录入时间']
          const filterVal = ['name', 'sexShow', 'birthday', 'phone', 'h_address', 'frequencyShow', 'projectShow', 'projectNoteShow', 'timelist', 'circumstances', 'createtime']
          excel.export_json_to_excel({
            header: tHeader,
            data: this.formatJson(filterVal, arr1),
            filename: '服务对象'
          })
          addexportlog({export_type: 1, export_cnt: arr1.length, filter_desc: filterDesc}).catch(() => {})
        })
        setTimeout(() => { this.$message.closeAll() }, 1500)
        return
      }

      // 授权用户：收集所有 homeid，批量查询设备信息
      let hids = []
      for (let i = 0; i < arr.length; i++) {
        let hid = arr[i].homeid || arr[i].hid
        if (hid && hids.indexOf(hid) === -1) {
          hids.push(hid)
        }
      }
      let devicePromise = hids.length > 0
        ? querybinddevicebyhome({hids: hids})
        : Promise.resolve({data: {devices: []}})

      devicePromise.then(deviceRes => {
        let devices = (deviceRes.data && deviceRes.data.devices) || []
        // 按 hid 分组设备
        let deviceMapByHid = {}
        for (let d of devices) {
          if (!deviceMapByHid[d.hid]) deviceMapByHid[d.hid] = []
          deviceMapByHid[d.hid].push(d)
        }

        let arr1 = []
        for (let i = 0; i < arr.length; i++) {
          let obj = Object.assign({}, arr[i])
          obj.sexShow = this.getSex(obj.sex)
          obj.frequencyShow = this.getFrequencyName(obj)
          obj.projectShow = this.getProjectName(obj)
          obj.projectNoteShow = this.getProjectRemark(obj)
          obj.orgPathShow = this.getOrgPath(obj.orgid)
          obj.communityShow = this.getCommunityNameById(obj.cid)

          // 设备信息（一个人可能有多个设备，用 / 分隔）
          let hid = obj.homeid || obj.hid
          let personDevices = deviceMapByHid[hid] || []
          if (personDevices.length > 0) {
            obj.deviceTypeShow = personDevices.map(d => this.commonType.getDeviceType(d.devicetype)).join(' / ')
            obj.deviceImeiShow = personDevices.map(d => d.deviceid || '').join(' / ')
            obj.deviceBindTimeShow = personDevices.map(d => d.createtime || d.bindtime || '').join(' / ')
          } else {
            obj.deviceTypeShow = ''
            obj.deviceImeiShow = ''
            obj.deviceBindTimeShow = ''
          }
          arr1.push(obj)
        }

        import('../../vendor/Export2Excel').then(excel => {
          const tHeader = ['姓名', '性别', '出生日期', '身份证号', '电话号码', '组织层级', '小区地址', '家庭地址', '服务频率', '所属项目', '项目备注', '接听电话时间段', '特殊情况', '设备类型', '设备IMEI', '绑定时间']
          const filterVal = ['name', 'sexShow', 'birthday', 'idcard_num', 'phone', 'orgPathShow', 'communityShow', 'h_address', 'frequencyShow', 'projectShow', 'projectNoteShow', 'timelist', 'circumstances', 'deviceTypeShow', 'deviceImeiShow', 'deviceBindTimeShow']
          const data = this.formatJson(filterVal, arr1)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: '服务对象'
          })
          addexportlog({export_type: 2, export_cnt: arr1.length, filter_desc: filterDesc}).catch(() => {})
        })
        setTimeout(() => {
          this.$message.closeAll()
        }, 1500)
      }).catch(() => {
        this.$message.closeAll()
        this.$message({type: 'error', message: '设备信息加载失败，已跳过设备字段导出'})
        // 降级：不含设备数据直接导出
        let arr1 = arr.map(item => {
          let obj = Object.assign({}, item)
          obj.sexShow = this.getSex(obj.sex)
          obj.frequencyShow = this.getFrequencyName(obj)
          obj.projectShow = this.getProjectName(obj)
          obj.projectNoteShow = this.getProjectRemark(obj)
          obj.orgPathShow = this.getOrgPath(obj.orgid)
          obj.communityShow = this.getCommunityNameById(obj.cid)
          obj.deviceTypeShow = ''
          obj.deviceImeiShow = ''
          obj.deviceBindTimeShow = ''
          return obj
        })
        import('../../vendor/Export2Excel').then(excel => {
          const tHeader = ['姓名', '性别', '出生日期', '身份证号', '电话号码', '组织层级', '小区地址', '家庭地址', '服务频率', '所属项目', '项目备注', '接听电话时间段', '特殊情况', '设备类型', '设备IMEI', '绑定时间']
          const filterVal = ['name', 'sexShow', 'birthday', 'idcard_num', 'phone', 'orgPathShow', 'communityShow', 'h_address', 'frequencyShow', 'projectShow', 'projectNoteShow', 'timelist', 'circumstances', 'deviceTypeShow', 'deviceImeiShow', 'deviceBindTimeShow']
          const data = this.formatJson(filterVal, arr1)
          excel.export_json_to_excel({header: tHeader, data, filename: '服务对象'})
          addexportlog({export_type: 2, export_cnt: arr1.length, filter_desc: filterDesc + '（设备信息加载失败）'}).catch(() => {})
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    // 查询频率
    getFrequency () {
      this.loading = true
      let data = {
        orgid: this.orgid
      }
      queryfrequency(data).then(res => {
        this.frequencys = res.data.frequencys
        this.addEdit.frequencys = this.frequencys
        this.quickObj.frequencys = this.frequencys
        this.getProjects()
      }).catch(() => {
        this.loading = false
      })
    },
    // 查询项目
    getProjects () {
      let data = {
        orgid: this.orgid
      }
      queryproject(data).then(res => {
        this.projects = res.data.projects
        this.addEdit.projects = this.projects
        this.quickObj.projects = this.projects
      }).catch(() => {
        this.loading = false
      })
    },
    // 加载小区/机构列表（供导出时映射小区名称）
    getCommunityList () {
      queryorgcommunity().then(res => {
        this.communitys = res.data.orgcommunitys || []
      }).catch(() => {})
    },
    checkChange (obj) {
      if (obj.type === 'check') {
        this.searchKeyword = ''
        this.isNumber = false
        this.currentPage = 1
        this.isFirst = obj.orgids
        this.getEndTable()
      } else if (obj.type === 'data') {
        this.orgData = obj.orgData
        this.addEdit.orgData = obj.orgData
        this.addEdit.orgTree = obj.treeData
        this.quickObj.orgOptions = obj.treeData
        this.getOldPersonTable()
      }
    },
    getUpdateTable () {
      this.getEndTable()
    },
    getEndTable () {
      this.oids = this.isFirst
      if (this.oids.length === 0) {
        this.getOldPersonTable()
      } else {
        this.getOldPersonTableByOids()
      }
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getFrequencyName (row) {
      let frequency = ''
      for (let i = 0; i < this.frequencys.length; i++) {
        if (row.frequencyid === this.frequencys[i].id) {
          frequency = this.frequencys[i].frequency
        }
      }
      return frequency
    },
    getProjectName (row) {
      let projectname = ''
      if (row.projectids !== null && row.projectids !== '' && row.projectids.length > 0) {
        for (let i = 0; i < row.projectids.length; i++) {
          if (projectname === '') {
            projectname = this.getProject2(row.projectids[i])
          } else {
            projectname = projectname + ',' + this.getProject2(row.projectids[i])
          }
        }
      } else {
        for (let i = 0; i < this.projects.length; i++) {
          if (row.projectid === this.projects[i].id) {
            projectname = this.projects[i].projectname
          }
        }
      }
      return projectname
    },
    getProject2 (id) {
      let projectname = ''
      for (let i = 0; i < this.projects.length; i++) {
        if (id === this.projects[i].id) {
          projectname = this.projects[i].projectname
        }
      }
      return projectname
    },
    getProjectRemark (row) {
      let projectremark = ''
      for (let i = 0; i < this.projects.length; i++) {
        if (row.projectid === this.projects[i].id) {
          projectremark = this.projects[i].remark
        }
      }
      return projectremark
    },
    // 通过 orgid 递归拼接组织层级路径，如：XX市 / XX街道 / XX社区
    getOrgPath (orgid) {
      if (!orgid || !this.orgData || this.orgData.length === 0) return ''
      let path = []
      let currentId = orgid
      let maxDepth = 20 // 防止死循环
      while (currentId && maxDepth-- > 0) {
        let org = this.orgData.find(o => o.id === currentId)
        if (!org) break
        path.unshift(org.name)
        if (!org.orgpid || org.orgpid === 0 || org.orgpid === org.id) break
        currentId = org.orgpid
      }
      return path.join(' / ')
    },
    // 通过 cid 查找小区/机构名称
    getCommunityNameById (cid) {
      if (!cid) return ''
      let community = this.communitys.find(c => c.id === cid)
      return community ? community.name : ''
    },
    // 新建服务对象
    addServiceObj () {
      this.quickObj.isAdd = true
      this.quickObj.oldPersonRow = ''
      this.quickObj.quickTitle = '新建服务对象'
      this.quickShow = true
    },
    // 编辑服务对象
    editServiceObj (row) {
      this.quickObj.isAdd = false
      this.quickObj.oldPersonRow = row
      this.quickObj.quickTitle = '修改服务对象'
      this.quickShow = true
    },
    // 删除服务对象
    delServiceObj (row) {
      let name = row.name
      this.$confirm('此操作将永久删除该服务对象【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          personids: [row.id]
        }
        deleteoldperson(data).then(res => {
          this.$notify({
            title: '成功',
            message: '删除服务对象成功',
            type: 'success',
            duration: 2000
          })
          if (this.showTable1.length === 1) {
            if (this.currentPage !== 1) {
              this.currentPage -= 1
            }
          }
          if (this.searchKeyword !== '') {
            this.searchWord()
          } else {
            if (this.oids.length === 0) {
              this.getOldPersonTable()
            } else {
              this.getOldPersonTableByOids()
            }
          }
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除服务对象失败'
          })
        })
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      if (this.searchKeyword !== '') {
        this.searchWord()
      } else {
        if (this.oids.length === 0) {
          this.getOldPersonTable()
        } else {
          this.getOldPersonTableByOids()
        }
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.searchKeyword !== '') {
        this.searchWord()
      } else {
        if (this.oids.length === 0) {
          this.getOldPersonTable()
        } else {
          this.getOldPersonTableByOids()
        }
      }
    },
    callServiceObj (row) {
      this.$router.push({path: '/videoZg', query: {id: row.id}})
      // this.store2.dispatch('other/update_old_person', row).then(() => {
      //   this.$router.push({path: '/videoZg', query: {id: row.id}})
      // })
    },
    openGrade (row) {
      this.evaluateObj.oldPersonRow = row
      this.evaluateShow = true
      // this.$router.push({path: '/evaluateAbility', query: {id: row.id}})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/serviceObject.vue